// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2704d85d","732":"21baa7b1","977":"c6a4c35d"}[chunkId] + ".chunk.js";
};